import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-description',
    templateUrl: './description.component.html'
})
export class DescriptionComponent {

    icon: string;
    header: string;
    title: string;
    description: string;

    constructor(route: ActivatedRoute) {
        this.icon = route.snapshot.data.icon;
        this.header = route.snapshot.data.header;
        this.title = route.snapshot.data.title;
        this.description = route.snapshot.data.description;
    }
}
